import AuthService from "./AuthService"
import ApiService from "./ApiService";

class NavigationService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._mainMenuUrl = '/navigation/main-menu';
    }
    mainMenu() {
        return this.postResource(this._mainMenuUrl, {}, this.getLangHeader());
    }
}

const Service = new NavigationService(AuthService);

export default Service;
